import { useEffect, useRef, useState } from "react";

const ScrollAnimation = ({ children, animation = "fade-up" }) => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`scroll-animate ${animation} ${visible ? "show" : ""}`}
    >
      {children}
    </div>
  );
};

export default ScrollAnimation; 